const Title = {

    "title":[
"Mr",
"Ms",
"Mrs",
    ]
};
export default Title;